export const TOAST_AUTO_CLOSE_DURATION = 5000;
